<x-chartist [type]="'Bar'" [data]="biPolarBarData" [options]="biPolarBarOptions" class="height-300">
</x-chartist>